// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import { StyledHiddenCheckbox } from "./HiddenCheckbox.styled";
import { StyledCheckboxControl } from "./CheckboxControl.styled";
import { StyledCheckIcon } from "./CheckIcon.styled";

// #####################################################

export const StyledCheckboxContainer = styled("span")`
	display: inline-block;
	vertical-align: text-bottom;
	line-height: 100%;
	margin-top: 0.2rem;
	margin-bottom: auto;

	${({ correctPosition }) =>
		correctPosition &&
		css`
			margin: 0;
		`}

	svg {
		color: ${({ theme }) => theme.colors.whiteTrue};
	}

	${({ theme: { colors } }) => css`
		${StyledHiddenCheckbox}:not(:checked) + ${StyledCheckboxControl} {
			background-color: ${({ theme: { colors } }) => colors.whiteTrue};
			border: 1px solid ${({ theme: { colors } }) => colors.inputBorder};
			&:focus
				${StyledHiddenCheckbox}:not(:checked)
				+ ${StyledCheckboxControl},
				&:hover
				${StyledHiddenCheckbox}:not(:checked)
				+ ${StyledCheckboxControl} {
				background-color: ${colors.white};
			}
		}

		&:active
			${StyledHiddenCheckbox}:not(:checked)
			+ ${StyledCheckboxControl} {
			background-color: ${({ theme: { colors } }) => colors.inputBorder};
		}

		${StyledHiddenCheckbox}:checked + ${StyledCheckboxControl} {
			background-color: ${colors.primary};
			${StyledCheckIcon} {
				visibility: visible;
			}
		}

		&:active ${StyledHiddenCheckbox}:checked + ${StyledCheckboxControl} {
			background-color: ${colors.primary};
		}

		&:hover
			${StyledHiddenCheckbox}:not(:checked)
			+ ${StyledCheckboxControl} {
			background-color: ${({ theme: { colors } }) => colors.itemsHover};
		}
	`}

	${({ $registerInEmail }) =>
		$registerInEmail &&
		css`
			padding: 0;
			border-radius: 0;
			background-color: transparent;

			&:active
				${StyledHiddenCheckbox}:not(:checked)
				+ ${StyledCheckboxControl} {
				background-color: transparent;
			}
			${StyledHiddenCheckbox}:not(:checked) + ${StyledCheckboxControl} {
				background-color: var(--dz-sys-checkbox-background-color);
			}
			&:focus
				${StyledHiddenCheckbox}:not(:checked)
				+ ${StyledCheckboxControl},
				&:hover
				${StyledHiddenCheckbox}:not(:checked)
				+ ${StyledCheckboxControl} {
				background-color: var(--dz-sys-checkbox-background-color-hover);
			}

			${StyledHiddenCheckbox}:checked + ${StyledCheckboxControl} {
				background-color: var(
					--dz-sys-checkbox-checked-background-color
				);
			}

			&:focus
				${StyledHiddenCheckbox}:checked
				+ ${StyledCheckboxControl},
				&:hover
				${StyledHiddenCheckbox}:checked
				+ ${StyledCheckboxControl} {
				background-color: var(
					--dz-sys-checkbox-checked-background-color
				);
			}
			&:active
				${StyledHiddenCheckbox}:checked
				+ ${StyledCheckboxControl} {
				background-color: var(
					--dz-sys-checkbox-checked-background-color
				);
			}
		`}

	${({ $customMargin }) =>
		$customMargin &&
		css`
			margin: ${$customMargin};
		`}
`;

// #####################################################
